<template>
  <form class="v-newsletter-form" @submit.prevent="onSubmit">
    <input class="c-input c-newsletter-form__email" type="text" :placeholder="t('Email')" v-model="email">
    <button type="submit" class="c-button c-button--large u-text-uppercase c-newsletter-form__submit" v-text="t('Subscribe')"></button>
  </form>
</template>
<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component
export default class NewsletterRedirectForm extends BaseComponent {
  @Prop({ type: String, required: true }) protected readonly redirect: string;

  protected email: string | null = null;

  protected onSubmit(): void {
    const params = new URLSearchParams(window.location.search);
    if (this.email) {
      params.append('email', this.email);
    }

    document.location.href = params.size ? `${this.redirect}?${params}` : this.redirect;
  }
}
</script>
